import React, {useState} from 'react';
import {Link} from 'gatsby';

// Bootstrap
import {Nav, Navbar, Row, Col} from 'react-bootstrap';

// Less
import './Header.less';

const Header = () => {
  const [dropdownClass, setDropdownClass] = useState('dropdown nav-item');
  const [dropdownMenuClass, setDropdownMenuClass] = useState('dropdown-menu');

  const handleOpen = () => {
    if (window.innerWidth > 960) {
      setDropdownClass('dropdown nav-item show');
      setDropdownMenuClass('dropdown-menu show');
    }
  };

  const handleClose = () => {
    if (window.innerWidth > 960) {
      setDropdownClass('dropdown nav-item');
      setDropdownMenuClass('dropdown-menu');
    }
  };

  const dropdownMobileOpen = () => {
    setDropdownClass('dropdown nav-item show');
    setDropdownMenuClass('dropdown-menu show');
  };

  const dropdownMobileClose = () => {
    setDropdownClass('dropdown nav-item');
    setDropdownMenuClass('dropdown-menu');
  };

  return (
    <header>
      <Navbar expand="lg" fixed="top" collapseOnSelect>
        <Link to="/" className="navbar-brand" aria-label="ensemble-logo" />
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">
          <Nav>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              className="collapsed-toggle"
            />
            <Link to="/" className="nav-link-mobile nav-link">
              Home
            </Link>

            <div
              className={dropdownClass}
              onMouseEnter={handleOpen}
              onMouseLeave={handleClose}
            >
              <div className="dropdown-button">
                <Link
                  className="dropdown-toggle nav-link"
                  id="basic-nav-dropdown"
                  role="button"
                  to="/services"
                >
                  Services
                </Link>
                <i className="im im-angle-right" onClick={dropdownMobileOpen} />
                <i className="im im-angle-down" onClick={dropdownMobileClose} />
              </div>

              <div
                className={dropdownMenuClass}
                aria-labelledby="basic-nav-dropdown"
              >
                <Row>
                  <Col md={6}>
                    <Link to="/services/aem" className="dropdown-item">
                      Adobe Technologies
                    </Link>
                    <ul className="sub-menu-lists">
                      <li>
                        <Link
                          to="/services/aem/mobile"
                          className="dropdown-item"
                        >
                          AEM Mobile
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/services/aem/forms"
                          className="dropdown-item"
                        >
                          AEM Forms
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/services/aem/sites"
                          className="dropdown-item"
                        >
                          AEM Sites
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/services/aem/assets"
                          className="dropdown-item"
                        >
                          AEM Assets
                        </Link>
                      </li>
                    </ul>
                  </Col>
                  <Col md={6}>
                    <Link
                      to="/services/microsoft-platforms"
                      className="dropdown-item"
                    >
                      Microsoft Platforms
                    </Link>
                    <Link
                      to="/services/mobile-app-development"
                      className="dropdown-item"
                    >
                      Mobile and Tablet
                    </Link>
                    <Link
                      to="/services/cloud-and-enterprise"
                      className="dropdown-item"
                    >
                      Cloud and Enterprise
                    </Link>
                    <Link
                      to="/services/tv-and-set-top-boxes"
                      className="dropdown-item"
                    >
                      Smart TVs and Connected Devices
                    </Link>
                  </Col>
                </Row>
              </div>
            </div>
            <Link className="nav-link" to="/about-us">
              About Us
            </Link>
            <Link className="nav-link" to="/careers">
              Careers
            </Link>
            <Link className="nav-link" to="/contact">
              Contact
            </Link>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    </header>
  );
};

export default Header;
